import { AccessibilityType } from '~client/model/accessibility-type';

/**
 * Returns TRUE if passed event type is streaming
 * @param type
 */
export const streaming = (type: AccessibilityType): boolean => type === AccessibilityType.STREAMING;

/**
 * Returns TRUE if passed event type is live attendance
 * @param type
 */
export const liveAttendance = (type: AccessibilityType): boolean =>
  type === AccessibilityType.LIVE_ATTENDANCE;



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-details.helper.ts